// /app/frontend/src/components/frugal-v2/providers/I18nProvider.jsx
// Wraps Frugal V2 with its own i18n context (25 lines)

import React from 'react';
import { I18nextProvider } from 'react-i18next';
import frugalI18n from '../i18n';

const FrugalI18nProvider = ({ children }) => {
  return (
    <I18nextProvider i18n={frugalI18n}>
      {children}
    </I18nextProvider>
  );
};

export default FrugalI18nProvider;
